export const REDUCER_NAME = 'topics';
